export default {
  notification: store => store.notification || 0,
  errorNotification: store => store.errorNotification || {},
};
